import React from 'react';
import { useParams } from 'react-router-dom';

export function Oauth() {
  const { status = '' } = useParams<{ status: string }>();
  return (
    <div className="container text-center oauth-page">
      <div className="row-fluid">
        <h1>{window.T(`oauth.${status}_title`)}</h1>
      </div>
      <div className="row-fluid">
        <p>{window.T(`oauth.${status}_desc`)}</p>
      </div>
      <div className="row-fluid" />
    </div>
  );
}
